import React from 'react'
import './sentry.scss'
import { Col, Row } from 'react-bootstrap'
import { images } from '../../../utils/customFn'

const SentryCard = ({data}) => {
    return (
        <div className='sentry_common_card'>
                <div className='the-sentry'>
                    <Row className='g-0'>
                        <Col sm={12} md={4} lg={4} xl={4}>
                            <div className='img-wrapper'>
                                <img src={data.banner} alt="img" />
                            </div>
                        </Col>
                        <Col sm={12} md={8} lg={8} xl={8}>
                            <div className='details-section'>
                                <h1>{data.heading}</h1>
                                <h2>{data.subheading}</h2>
                                <p>{data.para}</p>
                                <div className='trust-bottom'>
                                    <img src={data.sideImg} alt="icon" />
                                    <div className='text'>
                                        <h3>{data.sideheading}</h3>
                                        <p>{data.sidepara}</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
        </div>
    )
}

export default SentryCard